import * as React from 'react';
import { I as Icon } from './SvgIcon-f1131561.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgAccountNew = function SvgAccountNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M13.328 16.773C7.645 17.801 3.27 22.098 3.27 28v.8h25.46V28c0-5.902-4.375-10.2-10.058-11.227a6.582 6.582 0 0 1-2.672.559c-.953 0-1.86-.2-2.672-.559ZM27.902 27.2c-.437-5.832-5.597-9.867-11.902-9.867-6.305 0-11.465 4.035-11.898 9.867-.02.266-.032.531-.032.801h23.86c0-.27-.008-.535-.028-.8Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#fff",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M20 22.168a8.834 8.834 0 1 0-.001-17.667A8.834 8.834 0 0 0 20 22.168Zm0 0",
    transform: "scale(.8)"
  }));
};

var AccountNew = Icon(SvgAccountNew);

export { AccountNew as A };
//# sourceMappingURL=AccountNew-c15de3a3.js.map
